import { useEffect } from "react";
import { PhotoProvider, PhotoView } from "react-photo-view";
import {
  MdOutlineZoomIn,
  MdOutlineZoomOut,
  MdFullscreen,
} from "react-icons/md";
import { TbBoxMultiple } from "react-icons/tb";
import { FaRegCirclePlay } from "react-icons/fa6";
import "react-photo-view/dist/react-photo-view.css";
import "./photoGallery.css";

// Add your new Photo Gallery images here (Once added into the folder - public/img/photo-gallery)
const travelImagesSrc = [
  "/img/photo-gallery/1.webp",
  "/img/photo-gallery/2.webp",
  "/img/photo-gallery/3.webp",
  "/img/photo-gallery/4.webp",
  "/img/photo-gallery/5.webp",
  "/img/photo-gallery/6.webp",
  "/img/photo-gallery/7.webp",
  "/img/photo-gallery/8.webp",
  "/img/photo-gallery/9.webp",
  "/img/photo-gallery/10.webp",
  "/img/photo-gallery/11.webp",
  "/img/photo-gallery/12.webp",
  "/img/photo-gallery/13.webp",
  "/img/photo-gallery/14.webp",
  "/img/photo-gallery/15.webp",
  "/img/photo-gallery/16.webp",
  "/img/photo-gallery/17.jpeg",
  "/img/photo-gallery/18.jpeg",
  "/img/photo-gallery/19.jpeg",
  "/img/photo-gallery/20.png",
  "/img/photo-gallery/21.png",
  "/img/photo-gallery/22.png",
  "/img/photo-gallery/23.png",
  "/img/photo-gallery/24.png",
  "/img/photo-gallery/25.png",
  "/img/photo-gallery/26.png",
  "/img/photo-gallery/27.jpg",
  "/img/photo-gallery/28.jpg",
  "/img/photo-gallery/29.jpg",
  "/img/photo-gallery/30.jpg",
  "/img/photo-gallery/31.jpg",
  "/img/photo-gallery/32.jpg",
  "/img/photo-gallery/33.jpg",
  "/img/photo-gallery/34.jpg",
  "/img/photo-gallery/35.jpg",
  "/img/photo-gallery/36.jpg",
  "/img/photo-gallery/37.jpg",
  "/img/photo-gallery/38.jpg",
  "/img/photo-gallery/39.jpg",
  "/img/photo-gallery/40.jpg",
  "/img/photo-gallery/41.jpg",
  "/img/photo-gallery/42.jpg",
  "/img/photo-gallery/43.jpg",
  "/img/photo-gallery/44.jpg",
  "/img/photo-gallery/45.jpg",
  "/img/photo-gallery/46.jpg",
  "/img/photo-gallery/47.jpg",
  "/img/photo-gallery/48.jpg",
  "/img/photo-gallery/49.jpg",
  "/img/photo-gallery/50.jpg",
  "/img/photo-gallery/51.jpg",
  "/img/photo-gallery/52.jpg",
  "/img/photo-gallery/53.jpg",
  "/img/photo-gallery/54.jpg",
  "/img/photo-gallery/55.jpg",
  "/img/photo-gallery/56.jpg",
  "/img/photo-gallery/57.jpg",
  "/img/photo-gallery/58.jpg",
  "/img/photo-gallery/59.jpg",
  "/img/photo-gallery/60.jpg",
  "/img/photo-gallery/61.jpg",
  "/img/photo-gallery/62.jpg",
  "/img/photo-gallery/63.jpg",
  "/img/photo-gallery/64.jpg",
  "/img/photo-gallery/65.jpg",
  "/img/photo-gallery/66.jpg",
  "/img/photo-gallery/67.jpg",
  "/img/photo-gallery/68.jpg",
  "/img/photo-gallery/69.jpg",
];

const PhotoGallery = () => {
  useEffect(() => {
    document.title = "Travel Photo Gallery | Mango Holidays";
  }, []);

  return (
    <>
      {/* Banner Section */}
      <section className="banner-section-photoGallery">
        <div className="img-container-photoGallery">
          <img src="/img/photo-gallery.webp" alt="Banner Unavailable" />
        </div>
        <div className="banner-overlay-photoGallery">
          <h1 className="banner-title-photoGallery">Photo Gallery</h1>
        </div>
      </section>

      {/* Photos Section */}
      <section className="photos-section">
        <PhotoProvider
          maskOpacity={0}
          loop={true}
          toolbarRender={({ onScale, scale, onFullscreen, loop }) => (
            <div className="photo-provider-toolbar">
              <button>
                <TbBoxMultiple />
              </button>
              <button onClick={() => onScale(scale + 1)} title="Zoom In">
                <MdOutlineZoomIn />
              </button>
              <button onClick={() => onScale(scale - 1)} title="Zoom Out">
                <MdOutlineZoomOut />
              </button>
              <button onClick={onFullscreen} title="Fullscreen">
                <MdFullscreen />
              </button>
              <button onClick={loop} title="Loop">
                <FaRegCirclePlay />
              </button>
            </div>
          )}
        >
          {travelImagesSrc.map((imageSrc, index) => (
            <div key={index} className="travel-image-container">
              <PhotoView src={imageSrc}>
                <img src={imageSrc} alt={`Travel ${index + 1}`} />
              </PhotoView>
            </div>
          ))}
        </PhotoProvider>
      </section>
    </>
  );
};

export default PhotoGallery;
